export default {
  OPENSHIFT_INFO_REQUEST: (state) => {
    state.info.loading = true;
  },

  OPENSHIFT_INFO_FAILURE: (state, err) => {
    state.info.error = true;
    state.info.loading = false;
    state.info.errorMessage = err;
  },

  OPENSHIFT_INFO_SUCCESS: (state, {response}) => {
    state.info.error = false;
    state.info.loading = false;

    if (response && response.data && response.data.data) {
      const result = response.data.data;
      state.info.buildCommit = result.buildCommit;
      state.info.buildDate = result.buildDate;
      state.info.buildName = result.buildName;
      state.info.buildNamespace = result.buildNamespace;
      state.info.buildReference = result.buildReference;
      state.info.buildSource = result.buildSource;
      state.info.versionMajor = result.versionMajor;
      state.info.versionMinor = result.versionMinor;
      state.info.versionBuild = result.versionBuild;
    }
  },
}

